(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/collections/roundlist.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/collections/roundlist.js');

'use strict';

svs.game_results.collections.RoundList = Backbone.Collection.extend({
  model: svs.game_results.models.Round
});

 })(window);